/**
 * 资源清单：key → 路径（相对 index.html）。
 * 由 main.js 交给 Assets.load 全量预加载。
 */

/** 8 个角色（Kimi 表情衍生图） */
const CHAR_KEYS = ['happy', 'cool', 'angry', 'cry', 'confused', 'cheer', 'sleepy', 'moe'];

/** 30 个敌人（key 即 assets/img/enemies 下文件名去 .png） */
const ENEMY_KEYS = [
  's1_harpy', 's1_griffon', 's1_wisp', 's1_mid_air_elemental', 's1_boss_stormlord',
  's2_fish', 's2_goldfish', 's2_eel', 's2_shark', 's2_mid_jellyfish', 's2_boss_kraken',
  's3_ship1', 's3_ship2', 's3_ship3', 's3_mid_sentinel', 's3_boss_furnace',
  's4_deathcap', 's4_spore', 's4_lotus', 's4_drake', 's4_mid_mushroom', 's4_boss_treant',
  's5_ghost', 's5_imp', 's5_wraith', 's5_flayed', 's5_mid_lanterneye', 's5_boss_voideye',
  's6_star', 's6_eye', 's6_mass', 's6_cacodemon', 's6_mid_starspawn', 's6_boss_starcore',
  'ex_boss',
];

/** 32 个弹丸：4 形状 × 8 色 */
const BULLET_KINDS = ['orb', 'drop', 'star', 'pill'];
const BULLET_COLORS = ['red', 'orange', 'yellow', 'green', 'cyan', 'blue', 'purple', 'pink'];

/** 6 张背景 */
const BG_KEYS = ['bg1', 'bg2', 'bg3', 'bg4', 'bg5', 'bg6'];

/** 道具图标（独立方块图，与圆形弹丸明确区分；tools/gen-items.py 生成） */
const ITEM_IMAGES = {
  'item-P': 'assets/img/items/P.png',
  'item-B': 'assets/img/items/B.png',
  'item-POINT': 'assets/img/items/POINT.png',
  'item-STAR': 'assets/img/items/STAR.png',
  'item-1UP': 'assets/img/items/1UP.png',
};

const images = {};
for (const k of CHAR_KEYS) {
  images[k] = `assets/img/chars/${k}.png`;
  images[`${k}-l`] = `assets/img/chars/${k}-l.png`; // 移动帧：左倾
  images[`${k}-r`] = `assets/img/chars/${k}-r.png`; // 移动帧：右倾
}
for (const k of ENEMY_KEYS) images[k] = `assets/img/enemies/${k}.png`;
for (const kind of BULLET_KINDS) {
  for (const color of BULLET_COLORS) images[`${kind}_${color}`] = `assets/img/bullets/${kind}_${color}.png`;
}
for (const k of BG_KEYS) images[k] = `assets/img/bg/${k}.png`;
Object.assign(images, ITEM_IMAGES);

const audios = {
  bgm_title: 'assets/audio/bgm/title.ogg',
  bgm_stage1: 'assets/audio/bgm/stage1.ogg',
  bgm_stage2: 'assets/audio/bgm/stage2.ogg',
  bgm_stage3: 'assets/audio/bgm/stage3.ogg',
  bgm_stage4: 'assets/audio/bgm/stage4.ogg',
  bgm_stage5: 'assets/audio/bgm/stage5.ogg',
  bgm_stage6: 'assets/audio/bgm/stage6.ogg',
  bgm_ex_stage: 'assets/audio/bgm/exStage.ogg',
  bgm_boss: 'assets/audio/bgm/boss.ogg',
  bgm_boss1: 'assets/audio/bgm/boss1.ogg',
  bgm_boss2: 'assets/audio/bgm/boss2.ogg',
  bgm_boss3: 'assets/audio/bgm/boss3.ogg',
  bgm_boss4: 'assets/audio/bgm/boss4.ogg',
  bgm_boss5: 'assets/audio/bgm/boss5.ogg',
  bgm_boss6: 'assets/audio/bgm/boss6.ogg',
  bgm_clear: 'assets/audio/bgm/clear.ogg',
  bgm_credits: 'assets/audio/bgm/credits.ogg',
  shoot: 'assets/audio/sfx/shoot.wav',
  shot_happy: 'assets/audio/sfx/shot_happy.wav',
  shot_cool: 'assets/audio/sfx/shot_cool.wav',
  shot_angry: 'assets/audio/sfx/shot_angry.wav',
  shot_cry: 'assets/audio/sfx/shot_cry.wav',
  shot_confused: 'assets/audio/sfx/shot_confused.wav',
  shot_cheer: 'assets/audio/sfx/shot_cheer.wav',
  shot_sleepy: 'assets/audio/sfx/shot_sleepy.wav',
  shot_moe: 'assets/audio/sfx/shot_moe.wav',
  hit: 'assets/audio/sfx/hit.wav',
  explosion: 'assets/audio/sfx/explosion.wav',
  pickup: 'assets/audio/sfx/pickup.wav',
  bomb: 'assets/audio/sfx/bomb.wav',
  graze: 'assets/audio/sfx/graze.wav',
  special: 'assets/audio/sfx/special.wav',
  alarm: 'assets/audio/sfx/alarm.wav',
  death: 'assets/audio/sfx/death.wav',
  extend: 'assets/audio/sfx/extend.wav',
  cursor: 'assets/audio/sfx/cursor.wav',
  select: 'assets/audio/sfx/select.wav',
};

export const MANIFEST = { images, audios };
